import React, { Component } from 'react'
import './NavigationArrow.css'
import ArrowUp from '../../Images/arrow-up.svg'
import ArrowDown from '../../Images/arrow-down.svg'
import classNames from 'classnames'

class NavigationArrow extends Component {
  componentDidMount () {
    setInterval(() => {
      this.element.classList.toggle('tada')
    }, 2500)
  }

  render () {
    let { direction = 'down', visible = false } = this.props

    let classes = classNames({
      'NavigationArrow': true,
      'animated': true,
      'm-ArrowUp': direction === 'up',
      'm-ArrowDown': direction === 'down',
      'm-fadeIn': visible,
      'm-fadeOut': !visible
    })

    return (
      <div className={classes} onClick={this.props.onClick} ref={(element) => { this.element = element }}>
        {direction === 'up' && <img src={ArrowUp} alt='Go one slide up' draggable={false} />}
        {direction === 'down' && <img src={ArrowDown} alt='Go one slide down' draggable={false} />}
      </div>
    )
  }
}

export default NavigationArrow



// WEBPACK FOOTER //
// ./src/Components/NavigationArrow/NavigationArrow.js